import { useEffect, useState } from "react";
import { getPrincipalMessage } from "../Service/Api";
import InnerHaeder from "../Component/InnerHaeder";
import Highlights from "../Component/Highlights";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import HeadTag from "../Component/HeadTags";
import LazyLoad from "react-lazyload";

const PrincipalDesk = () => {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();

      const principalMessages = messages
        ?.filter((msg) => msg.category === "Principal")
        ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sort by date descending

      if (principalMessages?.length > 0) {
        setMessage(principalMessages[0]); // Latest one
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <HeadTag title="Principal's Desk" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5>
              <Link to="/">
                Home <i className="fas fa-angle-right"></i>
              </Link>
              <span>
                {" "}
                About Us <i className="fas fa-angle-right"></i> From Principal's
                Desk{" "}
              </span>
            </h5>
            <h2>From Principal's Desk</h2>
          </div>

          {message ? (
            <div className="message_inner">
              <div className="messagebox">
                <p>
                  <LazyLoad>
                    <img
                      src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${message.attachments}`}
                      className="inner_img"
                      alt="Principal"
                    />
                  </LazyLoad>
                </p>
                <p dangerouslySetInnerHTML={{ __html: message.message }} />
                <div className="clr20"></div>
                <p style={{textAlign:"center"}}>Warm Regards,</p>
                <h4>{message.name}</h4>
                <h5>
                  <strong>{message.category}</strong>
                </h5>
                <div className="clr"></div>
              </div>
            </div>
          ) : (
            <p>No principal message available.</p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrincipalDesk;
